import { render, staticRenderFns } from "./ResultNotify.vue?vue&type=template&id=e29670ea&scoped=true&"
import script from "./ResultNotify.vue?vue&type=script&lang=js&"
export * from "./ResultNotify.vue?vue&type=script&lang=js&"
import style0 from "./ResultNotify.vue?vue&type=style&index=0&id=e29670ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29670ea",
  null
  
)

export default component.exports